// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"6bcdef5e","455":"3152a8e3","720":"2f719647","908":"a3149552","977":"a1e36bcf"}[chunkId] + ".chunk.js";
};